import { convertToEnglishNumber } from "./convertToEnglishNumber";
import { createDecimalRegex, normalizeNumeric } from "./numericUtils";

const CheckValidity = (
  value,
  rules = {},
  controlName = "",
  decimalPrice = 0,
  isPercent = false,
) => {
  const validation = {
    isValid: true,
    errText: [],
    params: {},
  };

  if (!rules || Object.keys(rules).length === 0) {
    return validation;
  }
  //console.log("CheckValidity =", value );
  //console.log(rules);
  const raw =
    rules.isNumeric || rules.isPrice || rules.isPercent
      ? normalizeNumeric(value ?? "")
      : convertToEnglishNumber(value ?? "").trim();
  //console.log("CheckValidity raw=", raw );
  const rawNumber = Number(normalizeNumeric(raw));
  //console.log("CheckValidity rawNumber=", rawNumber );

  const setError = (key, params) => {
    validation.isValid = false;
    validation.errText.push(key);

    if (params) {
      validation.params = params;
    }
  };

  if (rules.required && raw === "") {
    setError(controlName ? "enter_amount_WID" : "enter_amount", {
      S1: controlName,
    });

    return validation;
  }

  if (Object.keys(rules).length === 1 && rules.required) {

    return validation;
  }

  if (rules.firstChar && raw && /^-?\d/.test(raw)) {
    setError("not_contain_number_in_first");

    return validation;
  }

  if (rules.justEnglish && !/^[A-Za-z0-9]*$/.test(raw)) {
    setError("only_English_letters");

    return validation;
  }

  if (rules.isNumeric) {
    if (raw === "-" || raw === "-.") {
      return validation;
    }

    if (!rules.isDecimal && raw.includes(".")) {
      setError("noDecimalAllowed");

      return validation;
    }

    if (rules.isDecimal) {
      const regex = createDecimalRegex(4, true);

      if (!regex.test(raw)) {
        setError("invalidDecimalFormat");

        return validation;
      }
    } else {
      const regex = /^-?\d+$/;

      if (!regex.test(raw)) {
        setError("typeNumberError");

        return validation;
      }
    }
  }

  if (rules.isPercent) {
    if (raw === "") {
      return validation;
    }

    if (raw === "-" || raw === "-.") {
      return validation;
    }

    if (raw.includes(".")) {
      setError("noDecimalAllowed");

      return validation;
    }

    const regex = createDecimalRegex(4, false);

    if (!regex.test(raw)) {
      setError("minimum_decimal_WID", {
        S1: 4,
      });

      return validation;
    }

    if (rawNumber < 0 || rawNumber > 100) {
      setError("wrongPercentage");

      return validation;
    }
  }

  if (rules.notZero && raw === "0") {
    setError("not_zero");

    return validation;
  }

  if (rules.isEmail) {
    const pattern =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (!pattern.test(raw)) {
      setError("invalidEmail");

      return validation;
    }
  }

  if (rules.minLength && raw.length < rules.minLength) {
    setError("minimum_char_WID", {
      S1: rules.minLength,
    });

    return validation;
  }

  if (rules.maxLength) {
    let testValue = raw;

    if (rules.isDecimal) {
      testValue = raw.replace(/\./g, "").replace(/-/g, "");
    }

    if (testValue.length > rules.maxLength) {
      setError("maximum_char_WID", {
        S1: rules.maxLength,
      });

      return validation;
    }
  }

  if (
    rules.min !== undefined &&
    raw !== "" &&
    raw !== "-" &&
    rawNumber < rules.min
  ) {
    setError("minimum_value_WID", {
      S1: rules.min,
    });

    return validation;
  }

  if (
    rules.max !== undefined &&
    raw !== "" &&
    raw !== "-" &&
    rawNumber > rules.max
  ) {
    setError("maximum_value_WID", {
      S1: rules.max,
    });

    return validation;
  }

  if (rules.isPrice) {
    if (raw === "" || raw === "-" || raw === "-.") {
      return validation;
    }

    if (Number(decimalPrice) === 0 && raw.includes(".")) {
      setError("noDecimalAllowed");

      return validation;
    }

    const regex = createDecimalRegex(Number(decimalPrice) || 0, true);

    if (!regex.test(raw)) {
      setError("minimum_decimal_WID", {
        S1: Number(decimalPrice) || 0,
      });

      return validation;
    }
  }

  if (rules.isPhone && !/^0\d{10}$/.test(raw)) {
    setError("invalidMobile");

    return validation;
  }

  if (rules.isPhoneSignUp) {
    if (raw.startsWith("0")) {
      if (raw.length !== 11) {
        setError("invalidMobile");

        return validation;
      }
    } else {
      if (raw.length !== 10) {
        setError("invalidMobile");

        return validation;
      }
    }
  }

  return validation;
};

export default CheckValidity;
